import {styled} from "@mui/material";

export const CampaignChangesContainer = styled('div', {
    name: 'CampaignChanges', slot: 'container',
    shouldForwardProp: (prop) =>
        prop !== 'variant' && prop !== 'sx',
    overridesResolver: (props, styles) => [
        styles.container
    ]
})({});

export const CampaignChangesTable = styled('table', {
    name: 'CampaignChanges', slot: 'table',
    shouldForwardProp: (prop) =>
        prop !== 'variant' && prop !== 'sx',
    overridesResolver: (props, styles) => [
        styles.table
    ]
})({});
